import { InputContainer } from '../styles'
import { PlainInputElement, PlainInputIconContainer } from './styles'
import { PlainInputProps } from './types'

/**
 * Renders the PlainInput component
 * @param {string} value - Value of input
 * @param {function} onChange - Triggered when user types input
 */

export const PlainInput: React.FC<PlainInputProps> = ({
  value,
  onChange,
  onFocus,
  onBlur,
  disabled,
  placeholder,
  type,
  min,
  stretch,
  transparent,
  grow,
  icon = null,
  error,
}) => {
  return (
    <InputContainer grow={grow} stretch={stretch} transparent={transparent}>
      <PlainInputIconContainer>{icon}</PlainInputIconContainer>
      <PlainInputElement
        $hasIcon={icon !== null}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
        type={type}
        transparent={transparent}
        min={min}
        $error={error}
      />
    </InputContainer>
  )
}
